import { atom } from 'jotai'
import type { VerificationInfoResponseLoadable } from '@/types/dashboard'
import { getVerificationInfo } from '@/services/verification/getVerificationInfo'
import type {
  StatesCoreTrackResponse,
  CommunicationsPreferenceCoreTrackResponse,
} from '@/types/verification'

export const isVerifyInfoFormInEditModeAtom = atom(false)

export const activeVerificationWorkOrderIndexAtom = atom<number>(0)

export const activeVerificationInfo = atom((get) => {
  const verificationInfo = get(verificationInfoAtom)
  const index = get(activeVerificationWorkOrderIndexAtom)
  if (
    !verificationInfo?.data?.data?.multipleWorkorders ||
    verificationInfo.data.data.multipleWorkorders.length === 0 ||
    index >= verificationInfo.data.data.multipleWorkorders.length
  ) {
    return null
  }
  return verificationInfo?.data?.data?.multipleWorkorders[index]
})

export const verificationInfoAtom = atom<VerificationInfoResponseLoadable>({
  isLoading: false,
  data: null,
})

export const fetchVerificationInfoAtom = atom(null, async (_, set) => {
  set(verificationInfoAtom, { isLoading: true, data: null })

  try {
    const result = await getVerificationInfo()

    set(verificationInfoAtom, { isLoading: false, data: result })
  } catch (_error) {
    // On error, ensure loading is reset and data is cleared
    set(verificationInfoAtom, { isLoading: false, data: null })
  }
})

export const stateDropdownOptionsAtom = atom<StatesCoreTrackResponse[]>([])

export const contactPreferenceOptionsAtom = atom<
  CommunicationsPreferenceCoreTrackResponse[]
>([])
